(function(window, documentWrapperFactory) {
   'use strict';

   var namespace = window.TSC = window.TSC || {};
   namespace.documentWrapper = documentWrapperFactory(window);
})(this, function(window) {
   'use strict';

   return {
      getDocument: function() {
         return window.document;
      }
   };
});
